import { inject } from '@angular/core';
import { Router, CanActivateFn, type RouterStateSnapshot } from '@angular/router';
import { TravelManagementService } from '../services/travel-management.service';
import { AuthApiSwitchService } from '../auth/auth-api-switch.service';
import { authGuard } from './auth.guard';

/** Travel admin: Firebase Auth when travel data is on Firestore; else Supabase. */
export const travelOwnerAuthGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const travelMgmt = inject(TravelManagementService);
  if (!travelMgmt.usesFirebase()) {
    return authGuard(_route, state);
  }

  const auth = inject(AuthApiSwitchService).for('firebase');
  const router = inject(Router);
  return auth.getSession().then(session => {
    if (session?.user?.uid) return true;

    void router.navigate(['/auth/login'], {
      queryParams: { api: 'firebase', rurl: state.url }
    });
    return false;
  });
};
